const navBar = document.querySelector('.nav-bar');
const mobileMenuToggle = document.querySelector('.js-toggle-mobile-menu');
const submenuToggles = document.querySelectorAll('.js-toggle-submenu');
const submenus = document.querySelectorAll('.submenu');

const isMobile = window.matchMedia('(max-width: 992px)');

function toggleActiveSubmenu(activeSubmenu) {
  submenus.forEach((submenu) => {
    if (submenu === activeSubmenu) {
      submenu.toggleAttribute('aria-hidden');
    }
  });
}

function closeSubmenus() {
  submenus.forEach((submenu) => {
    submenu.setAttribute('aria-hidden', '');
  });
}

if (navBar) {
  mobileMenuToggle?.addEventListener('click', () => {
    navBar.classList.toggle('nav-bar--mobile-menu-active');
    closeSubmenus();
  });

  submenuToggles.forEach((toggle) => {
    const currentSubmenu = toggle.parentElement.querySelector('.submenu');

    // Toggle submenu on click
    toggle.addEventListener('click', (e) => {
      e.preventDefault();

      toggleActiveSubmenu(currentSubmenu);
    });

    // Close active submenu on outside click
    window.addEventListener('click', (e) => {
      if (isMobile.matches) {
        return;
      }

      const currentSubmenuIsActive = currentSubmenu.getAttribute('aria-hidden') === null;

      if (!currentSubmenuIsActive) {
        return;
      }

      if (!currentSubmenu.contains(e.target) && !toggle.contains(e.target)) {
        setTimeout(() => currentSubmenu.setAttribute('aria-hidden', ''), 50);
      }
    });
  });
}
